import * as Sentry from '@sentry/browser'
import moment from 'moment'
import posthog from 'posthog-js'
import { initialize } from 'react-ga'

import { gaTrackingId } from './constants'
import { setupFirebase } from './services/firebase'
import { injectLocalAuth } from './utils/devAuth'
import { identifyFromStoredIdentity } from './utils/identify'
import { removerGrupoLegadoPartner } from './utils/posthog'
import { dropNoisyExceptions, maskCapturedNetworkRequest } from './utils/posthogFilters'
const { REACT_APP_API_ENV } = process.env

Sentry.init({
  dsn: 'https://fd35933272194285990bb729fdda03d2:103cbcf731c74269b10455c69c404453@sentry.io/2717568',
  environment: REACT_APP_API_ENV
})

// initial setup firebase
setupFirebase(REACT_APP_API_ENV)

moment.updateLocale('pt-br', require('moment/locale/pt-br'))

initialize({
  trackingId: gaTrackingId,
  useExistingGa: true,
  debug: false
})

posthog.init('phc_xezsjovH4ASvDk8DH8rF9PK4x35yFRcPkvCtaUhDnQYt', {
  api_host: 'https://us.i.posthog.com',
  defaults: '2026-05-30',
  capture_pageview: false,
  capture_pageleave: false,
  // Error tracking: exceções não tratadas e promises rejeitadas viram `$exception`.
  capture_exceptions: true,
  before_send: dropNoisyExceptions,
  // Session replay com privacidade primeiro: todo texto e todo input mascarados,
  // sem headers nem corpo de requisição. Blocos com dados bancários/PIX usam `ph-no-capture`.
  // maskCapturedNetworkRequest sanitiza as URLs de rede e também a URL da página gravada no replay.
  // A gravação só começa quando o replay for ligado no projeto PostHog.
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '*',
    recordHeaders: false,
    recordBody: false,
    maskCapturedNetworkRequestFn: maskCapturedNetworkRequest
  }
})

// Navegador que já passou pelo antigo `posthog.group('partner', ...)` guarda
// `$groups.partner` no storage do PostHog, e todo evento seguiria saindo com o
// grupo (cobrado em group analytics). O parceiro agora vai como super property.
// Remove só a chave `partner`: outro grupo que exista no storage fica.
removerGrupoLegadoPartner()
// O parceiro vale para o produto selecionado nesta visita: não pode vazar para
// a próxima abertura do app (outro produto ou outro usuário no mesmo
// navegador). O selectCrid grava de novo.
posthog.unregister('partnerId')
posthog.unregister('partnerName')

// DEV ONLY: injeta TOKEN e user_id no localStorage antes da app iniciar (no-op em produção)
injectLocalAuth()

identifyFromStoredIdentity()
